import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MultiSelectService {

  labelValue: string;
  cssValue: any;
  selectFlag: boolean;
  count = 0;
  constructor() {
    this.selectFlag = true;
    this.count = 0;
  }

  changeCssOnSingleSelectItem($event: any, val: number) {
    if ($event.target.checked) {
      document.getElementById('item' + val).style.background = 'rgb(39, 68, 104)';
      document.getElementById('item' + val).style.color = 'white';
      this.count++;
    } else {
      document.getElementById('item' + val).style.background = '#f0f0f0';
      document.getElementById('item' + val).style.color = 'black';
      this.count--;
    }
    return this.count;
  }

  changeCssOnSelectUnselectAll(itemArray: any) {
    this.count = 0;
    if (itemArray.every(val => val.checked === true)) {
      itemArray.forEach(val => { val.checked = false; });
      this.labelValue = 'Select all';
      this.selectFlag = false;
      this.cssValue = {background: '#f0f0f0', color: 'black'};
      return this.labelValue + '|' + JSON.stringify(this.cssValue) + '|' + this.count;
    } else {
      itemArray.forEach(val => { val.checked = true; this.count++; });
      this.labelValue = 'Deselect all';
      this.selectFlag = true;
      this.cssValue = {background: 'rgb(39, 68, 104)', color: 'white'};
      return this.labelValue + '|' + JSON.stringify(this.cssValue) + '|' + this.count;
    }
  }
}
